const styles = (theme) => ({
  root: {},
  bodyContainer: {
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing.unit * 2.5,
    },
  },
  title: {
    borderBottom: `1px solid ${theme.palette.primary.dark}`,
    paddingBottom: theme.spacing.unit * 2,
    position: 'relative',
  },
  edit: {
    '&&': {
      position: 'absolute',
      top: '-6px',
      right: 0,
      minHeight: 0,
      minWidth: 0,
      padding: 0,
      color: theme.palette.primary.dark,
    },
  },
  avatar: {
    marginTop: '0px',
    [theme.breakpoints.up('md')]: {
      marginTop: '10px',
    },
    color: theme.palette.custom.contacts,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  bold: {
    fontWeight: 600,
  },
});

export default styles;
